<template>
    <div class="app-container" :class="{ showSuccess: showSuccess }">
        <template v-if="showSuccess == false">
            <van-form @submit="onSubmit" @failed="onFailed" validate-first>
                <div class="question-box">
                    <div class="title">{{ form.area }}公交服务评价</div>
                    <div class="mt5">尊敬的各位乘客：</div>
                    <div class="desc">您好！为提升{{ form.area }}公共交通服务能力，推进公共交通系统建设，特此展开公共交通出行服务评价调查工作。 </div>
                    <div class="desc">此问卷不记名，仅供分析使用，感谢您的填写！</div>
                    <div class="questions">
                        <template v-for="(item, index) in list">
                            <div class="qestion-list"
                                v-if="item.questionOption == 0 || selectedAnwserIds.includes(item.questionOption)">
                                <div class="question-title" :class="{ require: item.questionOption ? true : false }">{{
                                    index +
                                    1 }}.{{ item.questionValue }}</div>
                                <van-field :name="'q_' + item.id"
                                    :rules="[{ validator, message: '您还有内容未评价哦~', extra: item.questionOption }]">

                                    <template #input>
                                        <div class="question-answer" v-if="item.questionType == '1'">
                                            <van-radio-group v-model:value="item.selected" checked-color="#FF8A21"
                                                icon-size="15px">
                                                <van-radio v-for="(vo, key) in item.appraiseOptionList" :key="key" :name="vo.id">{{
                                                    vo.optionValue
                                                }}</van-radio>
                                            </van-radio-group>
                                            <div class="textarea-box" v-if="item.showTextId == item.selected">
                                                <van-field rows="1" :name="'q_' + item.showTextId"
                                                    :rules="[{ required: item.optionSates ? true : false, message: '请填写内容' }]"
                                                    autosize v-model="item.diyContent" type="textarea" maxlength="20"
                                                    placeholder="请输入内容" show-word-limit />
                                            </div>
                                        </div>
                                        <div v-else class="question-answer">
                                            <van-checkbox-group checked-color="#FF8A21" icon-size="15px"
                                                v-model:value="item.selected">
                                                <van-checkbox v-for="(vo, key) in item.appraiseOptionList" shape="square" :key="key"
                                                    :name="vo.id">{{
                                                        vo.optionValue }}</van-checkbox>
                                            </van-checkbox-group>
                                            <div class="textarea-box" v-if="item.selected.includes(item.showTextId)">
                                                <van-field rows="1" autosize :name="'q_' + item.showTextId"
                                                    :rules="[{ required: item.optionSates ? true : false, message: '请填写内容' }]"
                                                    v-model="item.diyContent" type="textarea" maxlength="20"
                                                    placeholder="请输入内容" show-word-limit />
                                            </div>
                                        </div>
                                    </template>
                                </van-field>
                            </div>
                        </template>



                        <!-- <div class="qestion-list">
                    <div class="question-title">2.您一周乘坐公交的频率是？</div>
                    <div class="question-answer">
                        <van-checkbox-group checked-color="#FF8A21" icon-size="15px" v-model="result">
                            <van-checkbox shape="square" name="a">复选框 a</van-checkbox>
                            <van-checkbox shape="square" name="b">复选框 b</van-checkbox>
                        </van-checkbox-group>
                    </div>
                </div> -->
                    </div>
                </div>

                <div class="btn-box">
                    <van-button class="btn" round block type="info" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </template>
        <template v-else>
            <van-empty class="custom-image" description="感谢您的评价">
                <template #image>
                    <img src="../assets/imgs/success.png">
                </template>
            </van-empty>
        </template>
    </div>
</template>

<script>
import { getQuestions, submitQuestions, getAllCities } from "@/api/survey.js";
import { Base64 } from "js-base64";
import { Toast, RadioGroup, Radio, Checkbox, CheckboxGroup, Form, Field, Empty } from "vant";
export default {
    components: { RadioGroup, Radio, Checkbox, CheckboxGroup, Form, Field, Empty },
    data() {
        return {
            showSuccess: false,
            info: {},
            showText: [],
            list: [],
            form: {
                area: '',
                optionPOList: []
            },
            selectedAnwserIds: [] //已选中回答ID
        };
    },
    computed: {},
    watch: {
        list: {
            handler(newVal, oldVal) {
                this.selectedAnwserIds = [];
                newVal.forEach((item) => {
                    if (item.selected != null && typeof item.selected == 'object' && item.selected.length > 0) {
                        this.selectedAnwserIds.push(...item.selected)
                    }

                    if (item.selected != null && typeof item.selected != 'object' && item.selected) {
                        this.selectedAnwserIds.push(item.selected)
                    }

                })
            },
            // 开启深度监听 deep
            deep: true
        }
    },
    created() {
        let params = {
            head: {
                // deviceId: sessionStorage.getItem("deviceId"),
            },
            body: {
            },
        };
        getQuestions(params).then(res => {
            res.data = this.reset(res.data);
            this.$nextTick(() => {
                this.list = res.data
            })
        })
    },

    mounted() {
        console.log('route', this.$route)
        var info = this.$route.query.info
        if (info !== null) {
            info = decodeURIComponent(info);
            info = Base64.decode(info);
            info = JSON.parse(info);
            console.log('user',info)
            sessionStorage.setItem("token", info["MAASP-TOKEN"]);
            this.info = info;
        }
        var adcode = this.$route.query.adcode
        if (adcode !== null) {
            getAllCities().then(res => {
                console.log(adcode)
                let area = res.data.find((val) => {
                    return val.code == adcode
                })
                if (area !== undefined) {
                    this.form.area = area.city
                }
            });
        }

    },

    methods: {
        // callQuestion(vo){
        //     selectedAnwserIds.(item.questionOption)
        // },
        reset(datas) {
            datas.forEach(item => {
                if (item.questionType == '1') {
                    item.selected = null
                } else {
                    item.selected = [];
                }
                item.showTextId = -1;
                item.diyContent = '';
                item.appraiseOptionList.forEach((vo) => {
                    if (vo.optionType == 1) {
                        item.showTextId = vo.id;
                    }
                })
            })
            return datas;
        },
        validator(val, rule) {
            console.log('验证值', val, rule)

            if (this.selectedAnwserIds.includes(rule.extra)) {
                if ((typeof val == 'object' && val.length == 0) || (typeof val != 'object' && !val)) {
                    return false;
                } else {
                    return true;
                }

            }
            return true;
        },
        onSubmit(values) {
            let selectedFlag = false;
            for (let key in values) {
                if (values[key] != null && typeof values[key] == 'object' && values[key].length > 0) {
                    selectedFlag = true;
                    break;
                }
                if (values[key] != null && typeof values[key] != 'object' && values[key]) {
                    selectedFlag = true;
                    break;
                }
            }
            if (selectedFlag == false) {
                Toast.fail('您还有内容未评价哦~');
                return false;
            }
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '内容提交中',
            });
            this.list.forEach((item) => {
                if(item.questionOption == 0 || (item.questionOption >0 && this.selectedAnwserIds.includes(item.questionOption))){
                    item.appraiseOptionList.forEach((vo) => {
                    if (item.questionType == 1 && item.selected == vo.id) {
                        let ret = { "questionId": vo.questionId, "id": vo.id }
                        ret.optionValue = vo.optionType == 0 ? vo.optionValue : item.diyContent
                        this.form.optionPOList.push(ret)
                    }
                    if (item.questionType == 2 && item.selected.includes(vo.id)) {
                        let ret = { "questionId": vo.questionId, "id": vo.id }
                        ret.optionValue = vo.optionType == 0 ? vo.optionValue : item.diyContent
                        this.form.optionPOList.push(ret)
                    }
                })
                }
                
            })
            let params = {
                head: {
                    // deviceId: sessionStorage.getItem("deviceId"),
                },
                body: {
                },
            };
            params.body = this.form
            submitQuestions(params).then(res => {
                Toast.clear();
                if (res.code == 200) {
                    this.showSuccess = true;
                } else {
                    Toast.fail(res.msg);
                    return false;
                }
            })

            console.log('submit', this.form);
        },
        onFailed(errorInfo) {
            console.log('failed', errorInfo);
            Toast.fail(errorInfo.errors[0].message);
        },
    },
};
</script>

<style lang="scss" scoped>
.mt5 {
    margin-top: 5px;
}

.app-container {
    height: calc(100vh - 15px);
    background: #F6F6F6;
    font-size: 15px;
    padding: 15px 15px 0 15px;
    line-height: 18px;

    &.showSuccess {
        display: flex;
        justify-content: center;
    }

    .van-form {
        display: flex;
        flex-direction: column;

        .question-box {
            background-color: #FFF;
            padding: 13px 11px 0 11px;
            overflow-y: auto;
            height: calc(100vh - 130px);
            -webkit-overflow-scrolling: touch;

            &::-webkit-scrollbar {
                width: 2px;
                height: 2px;
                background-color: #F5F5F5;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 5px;
                -webkit-box-shadow: inset 0 0 5px #FF8A21;
                background: #FF8A21;
                transition: 0.3s ease-in-out;
            }

            &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 5px #eee;
                /* border-radius: 0; */
                background: rgba(0, 0, 0, 0.1);
            }

            .title {
                text-align: center;
                line-height: 22px;
                font-weight: bold;
            }

            .desc {
                text-indent: 2em;
            }

            .qestion-list {
                margin-top: 10px;

                ::v-deep {
                    .van-cell.van-field {
                        padding-left: 5px;
                    }

                    .van-radio-group,
                    .van-checkbox-group {
                        // padding-left: 5px;

                        .van-radio,
                        .van-checkbox {
                            margin-top: 5px;
                        }
                    }

                }

                .question-title {
                    font-weight: bold;
                    position: relative;

                }

                .question-title.require::before {
                    position: absolute;
                    left: -8px;
                    color: #ee0a24;
                    font-size: 14px;
                    content: '*';
                }

                .question-answer {
                    width: 100%;
                    display: block;
                }

                .textarea-box {
                    margin-top: 5px;
                    border: 1px solid #BBBBBB;

                    ::v-deep {
                        .van-cell {
                            padding-top: 0;
                            padding-bottom: 0;
                        }

                        .van-field__error-message {
                            display: none;
                        }
                    }

                }
            }
        }


        .btn-box {
            padding-top: 15px;
            padding-bottom: 39px;
            display: flex;
            align-content: center;
            flex: 1;

            .btn {
                width: 320px;
                height: 47px;
                background: #FF8921;
                border-radius: 24px;
                line-height: 47px;
                text-align: center;
                font-size: 18px;
                font-weight: 400;
                color: #FFFFFF;
                border: none;
                margin-left: 10px;
            }
        }
    }

}

.custom-image {
    ::v-deep {
        .van-empty__image {
            width: 44px;
            height: 44px;
        }

        .van-empty__description {
            font-size: 20px;
            font-weight: 400;
            color: #363636;
            line-height: 30px;
        }
    }


}</style>